import { render, staticRenderFns } from "./QuestionMatch.vue?vue&type=template&id=5f85554e&scoped=true&"
import script from "./QuestionMatch.vue?vue&type=script&lang=js&"
export * from "./QuestionMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f85554e",
  null
  
)

export default component.exports